export const ADD_NOTIFICATION = 'notifications/add'
export const SET_NOTIFICATIONS = 'notifications/set'
export const SET_TOTAL_UNREAD_NOTIFICATIONS = 'notifications/setTotalUnread'
export const READ_NOTIFICATION = 'notifications/read'
export const READ_ALL_NOTIFICATIONS = 'notifications/readAll'
export const DESTROY_NOTIFICATION = 'notifications/destroy'
